import { SearchBox } from '@/ux'
import { useState, useEffect } from 'react'
import { createRestClient } from '@/contexts/QueryProvider'
import { Loading } from '../Loading'
import { ErrorComponent } from '../ErrorComponent'
import { searchFilterGenerator } from './functions'
import './Landing.scss'
import { FluentCardLanding } from '../FluentCard/FluentCardLanding'
import { ENDPOINTS } from '@/util/endpoints'
import { useSessionStorage } from '@/hooks'
import { isProjectMember } from '@/util'
import { catalogApps } from '@/const'

// Parent Component
export function LandingWorkspaces() {
  const [searchString, setSearchString] = useState<string>('')

  const [userRole] = useSessionStorage('roles', 1)

  if (isProjectMember(userRole))
    return (
      <>
        <div className="second-level-menu-container">
          <div></div>
          <div></div>
          <SearchBox searchString={searchString} setSearchString={setSearchString} />
        </div>
        <PageContent searchString={searchString} />
      </>
    )
  else return <div className="card-container">You do not have access to workspaces.</div>
}

// Child Component: PageContent
function PageContent({ searchString }: { searchString: string }) {
  const { getWorkspacesApiGetCurrentUserWorkspaces } = createRestClient()
  const { data: applicationProjects, isPending, isError, refetch } = getWorkspacesApiGetCurrentUserWorkspaces.useQuery()

  useEffect(() => {
    // Manually trigger the query when the component mounts
    refetch()
  }, [refetch])

  const searchFilter = searchFilterGenerator(searchString)

  if (isPending) return <Loading />
  if (isError) return <ErrorComponent />

  // Filter application projects using the search filter
  const filteredProjects = applicationProjects?.filter((item) => searchFilter(item)) || []

  return (
    <div className="card-container">
      {filteredProjects.length > 0 ? (
        filteredProjects.map(
          ({
            app_key,
            project_id,
            organisation_id,
            organisation,
            workspaceId,
            project,
            application,
            card,
            terms_and_conditions_accepted,
            terms_and_conditions_url,
            privacy_statement_url,
            app_id,
          }) => {
            const catalogAppPath = `/apps/${app_key}/home?appId=${app_id}&projectId=${project_id}`
            const unityAppPath = `/${app_key}/home?pid=${project_id}`
            const launchAppPath = catalogApps.includes(app_key)
              ? `/apps/${app_key}/home?appId=${app_id}&projectId=${project_id}`
              : `/${app_key}/home?pid=${project_id}`
            const workspaceDetailsPath = `/workspace?orgId=${organisation_id}&orgName=${organisation}&subscriptionId=${workspaceId}&tab=details&appKey=${app_key}&appName=${application}&projectId=${project_id}&projectName=${project}`
            const backgroundImageUrl = `${ENDPOINTS.DOTNET}/rest/support/getImage?imageKey=${card.image}`
            return (
              <FluentCardLanding
                key={`${app_key}-${project_id}`}
                appId={app_id}
                optionalText={application}
                description={organisation}
                title={project}
                termsAccepted={terms_and_conditions_accepted}
                termsUrl={terms_and_conditions_url}
                privacyUrl={privacy_statement_url || undefined}
                // launchAppPath={launchAppPath}
                launchAppPath={catalogApps.includes(app_key) ? catalogAppPath : unityAppPath}
                unityAppPath={catalogApps.includes(app_key) ? unityAppPath : undefined}
                workspaceDetailsPath={workspaceDetailsPath}
                backgroundImage={backgroundImageUrl}
              />
            )
          }
        )
      ) : (
        <p className="no-results">No results found {searchString !== '' && <>for &quot;{searchString}&quot;.</>}</p>
      )}
    </div>
  )
}
